module.exports = __webpack_public_path__ + "static/media/chambers-global-practice-guide.2b1f4054.pdf";